"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enUS = exports.RenderMode = exports.LOCAL = exports.LOADER_NAMESPACE = exports.CDN_LOCAL_URL = exports.CDN_BASE_URL = void 0;
var CDN_BASE_URL = exports.CDN_BASE_URL = 'https://img1.wsimg.com';
var CDN_LOCAL_URL = exports.CDN_LOCAL_URL = 'https://localhost:9044'; // Should match devServer settings in webpack.app.config.js in cli
var LOADER_NAMESPACE = exports.LOADER_NAMESPACE = 'ml';
var LOCAL = exports.LOCAL = 'local';
var RenderMode = exports.RenderMode = {
  MODAL: 'modal',
  EMBED: 'embed'
};
var enUS = exports.enUS = 'en-US';